import React from "react";

import Input from "../../../components/Input";
import InputSelect from "../../../components/InputSelect";
import { FISCAL_ORIGINS, FISCAL_UNITS } from "../../Fiscal/helpers";

/**
 * Informações fiscais do produto (BDM-887).
 *
 * Estavam misturadas com nome, destaque e novidade em "Informações gerais" —
 * quem cadastra produto e quem cuida do fiscal raramente são a mesma pessoa,
 * e a cada emissão de nota rejeitada é aqui que se vem procurar.
 *
 * O que é do PRODUTO fica aqui; como a operação é tributada (CFOP, CST/CSOSN,
 * alíquotas) é da natureza de operação, não do cadastro.
 */
export const ProductFiscalTab = ({
    ncm,
    setNcm,
    cest,
    setCest,
    fiscalOrigin,
    setFiscalOrigin,
    fiscalUnit,
    setFiscalUnit,
    gtin,
    setGtin,
}) => {
    return (
        <div className="product-fiscal-tab">
            <div className="row">
                <div className="col-6">
                    <h2 className="section-title">Informações fiscais</h2>

                    <div className="row">
                        <div className="col-6">
                            <Input
                                label={`NCM`}
                                value={ncm}
                                change={setNcm}
                                mask={`convertToNCM`}
                            />
                        </div>
                        <div className="col-6">
                            <Input label={`CEST`} value={cest} change={setCest} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <InputSelect
                                label={`Unidade`}
                                options={FISCAL_UNITS}
                                value={fiscalUnit}
                                change={setFiscalUnit}
                            />
                        </div>
                        <div className="col-6">
                            <Input label={`Código de barras (GTIN/EAN)`} value={gtin} change={setGtin} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <InputSelect
                                label={`Origem da mercadoria`}
                                options={FISCAL_ORIGINS}
                                value={fiscalOrigin}
                                change={setFiscalOrigin}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductFiscalTab;
